<template>
  <el-main>
    <div class="scale">
      <el-button icon="el-icon-minus" size="small" @click="scale -= 10" :disabled="scale <= 40" circle></el-button>
      <span>{{ scale }}%</span>
      <el-button icon="el-icon-plus" size="small" @click="scale += 10" :disabled="scale >= 150" circle></el-button>
    </div>
    <div class="design" :style="'transform: scale('+ scale / 100 +');'">
      <process-tree ref="process-tree" @selectedNode="nodeSelected"/>
    </div>
    <el-drawer :title="selectedNode.name" :visible.sync="showConfig"
               :size="currentDrawerSize"
               direction="rtl" :modal="false" append-to-body destroy-on-close>
      <div slot="title">
        <focus-input v-model="selectedNode.name"
                     size="medium"
                     style="width: 300px">
          <template #default="{showInput}">
            <el-link v-show="!showInput" style="font-size: medium; line-height: 36px;">
              <i class="el-icon-edit" style="margin-right: 10px"></i>
              {{selectedNode.name}}
            </el-link>
          </template>
        </focus-input>
      </div>
      <div class="node-config-content">
        <node-config />
      </div>
    </el-drawer>
  </el-main>
</template>

<script>
import ProcessTree from '../process/ProcessTree'
import NodeConfig from '../process/config/NodeConfig'
import FocusInput from '../common/FocusInput'

export default {
  name: 'ProcessDesign',
  inject: ['$workflow'],
  components: {ProcessTree, NodeConfig, FocusInput},
  data () {
    return {
      scale: 100,
      selected: {},
      showConfig: false
    }
  },
  computed: {
    selectedNode () {
      return this.$workflow.selectedNode
    },
    currentDrawerSize () {
      const selectedNode = this.selectedNode
      if (selectedNode) {
        switch (selectedNode.type) {
          case 'CONDITION':
          case 'INCLUSIVE':
            return '600px'
        }
      }
      return '500px'
    }
  },
  methods: {
    validate () {
      return this.$refs['process-tree'].validateProcess()
    },
    nodeSelected (node) {
      this.$emit('selectedNode', node)
      this.showConfig = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .design {
    margin-top: 100px;
    display: flex;
    transform-origin: 50% 0 0;
  }

  .el-main {
    height: 100%;
  }

  .scale {
    z-index: 999;
    position: absolute;
    top: 15px;
    right: 25px;

    span {
      margin: 0 10px;
      font-size: 15px;
      color: #7a7a7a;
      width: 50px;
    }
  }

  .node-config-content{
    padding: 0 20px 20px;
  }

  ::v-deep .el-drawer__body{
    overflow-y: auto;
  }
</style>
